import React from "react";
import { Gauge, SlidersHorizontal, UserCheck, Users, Zap, Target, Compass, Laptop, Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const stressAreas = [{
  id: "workload-pressure",
  title: "Workload Pressure",
  description: "Managing the volume and demands of tasks to prevent burnout and maintain sustainable productivity levels.",
  icon: Gauge
}, {
  id: "work-control",
  title: "Work Control",
  description: "The level of autonomy and influence employees have over how they perform their daily responsibilities.",
  icon: SlidersHorizontal
}, {
  id: "manager-backing",
  title: "Manager Backing",
  description: "The support, guidance, and encouragement provided by direct supervisors and organizational leadership.",
  icon: UserCheck
}, {
  id: "team-backing",
  title: "Team Backing",
  description: "The quality of peer relationships, collaboration, and mutual support within the immediate work group.",
  icon: Users
}, {
  id: "workplace-friction",
  title: "Workplace Friction",
  description: "Addressing interpersonal conflicts, toxic behaviors, and systemic barriers to a harmonious environment.",
  icon: Zap
}, {
  id: "role-clarity",
  title: "Role Clarity",
  description: "Ensuring clear understanding of job expectations, responsibilities, and how they align with goals.",
  icon: Target
}, {
  id: "change-confidence",
  title: "Change Confidence",
  description: "The ability of the workforce to adapt to organisational changes with adequate communication and support.",
  icon: Compass
}, {
  id: "tools-tech-training",
  title: "Tools, Tech & Training",
  description: "Providing the necessary resources, equipment, and skill development to perform tasks effectively.",
  icon: Laptop
}, {
  id: "hidden-barriers-support",
  title: "Hidden Barriers & Support",
  description: "Whether unseen difficulties are understood, supported and not made worse by the way work is set up.",
  icon: Shield
}];
export default function EightStressRiskAreas() {
  return <section id="eight-stress-risk-areas" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold md:text-4xl">The Nine Stress Risk Areas</h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Understanding and addressing these key domains is essential for
            fostering a healthy, resilient, and high-performing workplace.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {stressAreas.map((area, index) => {
          const Icon = area.icon;
          return <Card key={area.id} data-index={index} className="group border-border/50 bg-card hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <CardHeader className="pb-4">
                  <div className="text-ring mb-4 transition-transform duration-300 group-hover:scale-110">
                    <Icon size={32} strokeWidth={2} />
                  </div>
                  <CardTitle className="font-default text-chart-5 text-xl font-bold">
                    {area.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-foreground text-base leading-relaxed">
                    {area.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}